
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subastas",
      function () {
        return require("private-next-pages/subastas/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subastas"])
      });
    }
  